import React, { Component } from "react";
import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Responsive from "react-responsive";
import AppHeader from "../AppHeader/AppHeader";
import AppTheme from "../AppTheme";

import Button from "@material-ui/core/Button";

import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import logoImage from "../assets/logo-white.png";

import {
  getManevre,
  getPatientsAdmin,
  getEvents,
  addEvent,
  getEventsByPatientID,
  getEventsByVolunteerID,
  getVoluntarDetailsById,
  deleteEvent
} from "../services/volunteer";

import styles from "./VolunteerFormStyles";

const localizer = momentLocalizer(moment);

const Desktop = props => <Responsive {...props} minWidth={750} />;

const Mobile = props => <Responsive {...props} maxWidth={749} />;

function Event({ event }) {
  return (
    <span>
      <strong style={{ fontSize: 24 }}>{event.volunteer.name}</strong>
         {/*<p>{event.type ? event.type.name : ""}</p>*/}
         <p style={{ fontStyle: "italic" }}>{event.desc ? event.desc : ""}</p>
    </span>
  );
}

function EventAgenda({ event }) {
  return (
    <span>
      <p
        style={{
          color: "#ff0",
          fontWeight: 900,
          fontSize: 28,
          lineHeight: 1.5
        }}
      >
        {event.volunteer.name}
      </p>
      <p
        style={{
          color: "#fff",
          fontWeight: 900,
          fontSize: 28,
          lineHeight: 1.5
        }}
      >
        {event.resourceId.name}
      </p>
      <p
        style={{
          color: "#fff",
          fontWeight: 500,
          fontSize: 16,
          lineHeight: 1.5
        }}
      >
        {event.desc}
      </p>
    </span>
  );
}

const customDayPropGetter = date => {
  if (moment(date).weekday() === 6 || moment(date).weekday() === 5)
    return {
      className: "special-day",
      style: {
        border: "solid 3px #faa"
      }
    };
  else return {};
};

const eventPropGetter = (event, start, end, isSelected) => {
  return {
    className: "event-type" + event.type.code,
    style: {
      border: "solid 3px #faa"
    }
  };
};

class VolunteerForm extends Component {
   constructor (props) {
    super(props);
    this.state = {
      patients:null,
      manevre: [],
      events:[],
      selected: 0,
      intervalId: 0,
      interval: 10000,
    };
    this.load = this.load.bind(this);
  }
   
   async componentWillMount() {
    const patients = await getPatientsAdmin();
    //console.log(patients);
    let events =[] 
    if (patients && patients.length >0) {
      events = await getEventsByPatientID(patients[0]._id);
    }
    
    
    this.setState({
      patients,
      events
    });
  }

  componentWillUnmount() {
    document.title = 'Program Voluntariat - Calendar Voluntari'
    clearInterval(this.state.intervalId);
  }

  async componentDidUpdate(prevProps, prevState) {
   if (prevState.selected!== this.state.selected) {
    const events = await getEventsByPatientID(this.state.patients[this.state.selected]._id);
    this.setState({ events });
   }
  }

  async timer() {
    let selected = (this.state.selected + 1) % this.state.patients.length;
    const events = await getEventsByPatientID(this.state.patients[this.state.selected]._id);
    this.setState({ selected,events, selectedDate:new Date() });
  }

  async load ( event) {
    //console.log(event);
    const events = await getEventsByPatientID(this.state.patients[event.currentIndex]._id);
    this.setState({ events, selectedDate:new Date() });
  }
  


  render() {
    const { classes } = this.props;
    const { viewModel } = this.state;
    return (
      <MuiThemeProvider theme={AppTheme}>
        <div className={classes.volunteerForm}>
        <AppBar>
        <Toolbar>
          <i className="material-icons appToolbar-menu">menu</i>
          <img src={logoImage} style={{ height: 50 }} alt="logo" />
          <h1 className="appToolbar-title">Calendar Voluntariat</h1>
          <Button
            color="primary"
            variant={"contained"}
            href="/setari-voluntari"
          >
            Setari Voluntari
          </Button>
       
        </Toolbar>
      </AppBar>
            <Paper className={classes.formContainer}>
             {this.state.patients &&  <AwesomeSlider
                bullets={false}
                infinite={true}
                organicArrows={true}
                selected={this.state.selected}
                onTransitionEnd={this.load}
                onFirstMount={() => {
                  const intervalId = setInterval(
                    this.timer.bind(this),
                    this.state.interval
                  );
                  this.setState({ intervalId });
                }}
                style={{height:"100px",backgroundColor:"#fff"}}
              >
                {this.state.patients.map((patient, i) => {
                  return (
                    <div key={i} style={{height:"100px", backgroundColor:"#fff"}}>
                      <h1 style={{paddingTop:10}}>{patient.name}</h1>
                    </div>
                  );
                })}
              </AwesomeSlider>}
              <Desktop>
                <Calendar
                  localizer={localizer}
                  culture={"ro"}
                  drilldownView="agenda"
                  className={classes.calendar}
                  events={this.state.events}
                  defaultView={Views.WEEK}
                  min={moment("8:00am", "h:mma").toDate()}
                  max={moment("8:00pm", "h:mma").toDate()}
                  views={["day", "week", "agenda"]}
                  step={60}
                  timeslots={1}
                  popup={true}
                  
                  onSelectSlot={this.handleSelect}
                  showMultiDayTimes={true}
                  eventPropGetter={eventPropGetter}
                  date={this.state.selectedDate}
                  onNavigate={date => {
                    this.setState({ selectedDate: date });
                  }}
                  components={{
                    event: Event,
                    agenda: {
                      event: EventAgenda
                    }
                  }}
                  messages={{
                    date: "Data",
                    time: "Ora",
                    event: "Eveniment",
                    allDay: "Toata ziua",
                    week: "Saptamana",
                    work_week: "Saptamana lucratoare",
                    day: "Zi",
                    month: "Luna",
                    previous: "<--",
                    next: "-->",
                    yesterday: "Ieri",
                    tomorrow: "Maine",
                    today: "Astazi",
                    agenda: "Agenda",
                    noEventsInRange: "Nu sunt inregistrari in aceasta perioada!"
                  }}
                />
              </Desktop>
              <Mobile>
                <Calendar
                  localizer={localizer}
                  culture={"ro"}
                  drilldownView="agenda"
                  className={classes.calendar}
                  events={this.state.events}
                  defaultView={Views.DAY}
                  min={moment("8:00am", "h:mma").toDate()}
                  max={moment("8:00pm", "h:mma").toDate()}
                  views={["day","agenda"]}
                  step={60}
                  timeslots={1}
                  popup={true}
                  onSelectSlot={this.handleSelect}
                  dayPropGetter={customDayPropGetter}
                  showMultiDayTimes={true}
                  eventPropGetter={eventPropGetter}
                  date={this.state.selectedDate}
                  onNavigate={date => {
                    this.setState({ selectedDate: date });
                  }}
                  components={{
                    event: Event,
                    agenda: {
                      event: EventAgenda
                    }
                  }}
                  messages={{
                    date: "Date",
                    time: "Time",
                    event: "Event",
                    allDay: "All Day",
                    week: "Saptamana",
                    work_week: "Saptamana lucratoare",
                    day: "Zi",
                    month: "Month",
                    previous: "<--",
                    next: "-->",
                    yesterday: "Ieri",
                    tomorrow: "Maine",
                    today: "Astazi",
                    agenda: "Agenda",

                    noEventsInRange: "Nu sunt inregistrari in aceasta perioada!"
                  }}
                />
              </Mobile>
            </Paper>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(VolunteerForm);
